import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "./../../redux/actions/menuActions";
import accountMenu from "./Menu";

import AuthRender from "../../containers/AuthRender";
import { SERVICES } from "../../configs/constants";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("accounting");
    this.props.setMenuLeftItemIndex("");
    this.props.setMenuLeftContent(accountMenu);
  }

  render() {
    return (
      <div className="p-landing">
        <AuthRender service={SERVICES.Virement}>Comptabilité</AuthRender>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/accounting/Home.js